import Vue from 'vue';
import Router from 'vue-router';
import AuthFilter from '@/auth/filter';
import Page from '@/views/Page.vue';
import Logout from '@/views/Logout.vue';

// import LoginGoogle from '@/views/LoginGoogle.vue';
// import LoginCognito from '@/views/LoginCognito.vue';
// import CognitoCallback from '@/views/CognitoCallback.vue';
// import Loading from '@/views/Loading.vue';

import LoginAuth0 from '@/auth/auth0/views/LoginAuth0.vue';
import Auth0Callback from '@/auth/auth0/views/Auth0Callback.vue';

import pageRoutes from '@/routes';
import assetsRoutes from '@/routes/assets';
import analyticsRoutes from '@/routes/analytics';
import profilesRoutes from '@/routes/profiles';
import actionsRoutes from '@/routes/actions';
import deploymentsRoutes from '@/routes/deployments';
import dashboardRoutes from '@/routes/dashboard';
import alertsRoutes from '@/routes/alerts';
import logsRoutes from '@/routes/logs';
import adminRoutes from '@/routes/admin';
import insightsRoutes from '@/routes/insights';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      // name: 'loading',
      // component: Loading,
      redirect: '/dashboard',
    },
    {
      path: '/login',
      name: 'login',
      component: LoginAuth0,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/callback',
      name: 'callback',
      component: Auth0Callback,
    },
    {
      path: '/',
      component: Page,
      children: pageRoutes.concat(
        dashboardRoutes,
        alertsRoutes,
        logsRoutes,
        analyticsRoutes,
        assetsRoutes,
        profilesRoutes,
        actionsRoutes,
        deploymentsRoutes,
        adminRoutes,
        insightsRoutes,
      ),
    },
  ],
});

router.beforeEach(AuthFilter);

export default router;
